import { Card, CardBody } from '@img/ui';
import { Link } from 'react-router-dom';

/**
 * 📜 الشروط والأحكام — شركة صورة العقارية
 * تحكم استخدام المنصة (تسجيل، إعلانات، مزادات، اشتراكات، مدفوعات).
 */
export function TermsPage() {
  return (
    <div className="bg-gradient-to-b from-navy-soft/30 to-white">
      {/* Hero */}
      <section className="bg-gradient-to-l from-navy-darker via-navy-dark to-navy text-white py-14 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-6xl mb-3">📜</div>
          <h1 className="text-3xl md:text-4xl font-black mb-3">الشروط والأحكام</h1>
          <p className="text-gold-light text-base leading-relaxed max-w-2xl mx-auto">
            تنظّم هذه الوثيقة العلاقة بينك وبين <b>شركة صورة العقارية</b> عند استخدامك لمنصّتنا (img.sa) وأي من خدماتها.
          </p>
          <p className="text-gray-400 text-sm mt-4">آخر تحديث: محرّم ١٤٤٧ هـ</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-10 space-y-5">
        <Card><CardBody>
          <p className="text-sm text-gray-700 leading-relaxed">
            باستخدامك المنصة فإنك توافق صراحةً على الالتزام بهذه الشروط، وبأنظمة المملكة العربية السعودية ذات الصلة، ولوائح الهيئة العامة للعقار (REGA).
            إذا لم توافق على أي بند، يجب عليك الامتناع عن استخدام المنصة فوراً.
          </p>
        </CardBody></Card>

        <Section n="1" title="التعريفات">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li><b>المنصة:</b> الموقع والتطبيقات التابعة لـ شركة صورة العقارية على النطاق img.sa.</li>
            <li><b>المستخدم:</b> أي شخص طبيعي أو اعتباري يُسجّل أو يستخدم المنصة.</li>
            <li><b>المسوّق العقاري:</b> مستخدم يحمل اشتراكاً نشطاً ضمن باقات «منصة التسويق العقاري» ومُرخَّص بموجب نظام «فال».</li>
            <li><b>الإعلان:</b> أي عرض عقاري (بيع/إيجار/استثمار/مزاد) يُنشر عبر المنصة.</li>
            <li><b>المحتوى:</b> النصوص، الصور، الفيديوهات، البيانات، والوثائق المنشورة من قِبَل المستخدمين أو المنصة.</li>
          </ul>
        </Section>

        <Section n="2" title="التسجيل والحساب">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>يجب أن لا يقل عمر المستخدم عن ١٨ سنة.</li>
            <li>يلتزم المستخدم بتقديم بيانات صحيحة ومحدّثة، ويتحمّل وحده مسؤولية أي بيانات مغلوطة.</li>
            <li>يحظر إنشاء أكثر من حساب لشخص واحد إلا بإذن مكتوب من إدارة المنصة.</li>
            <li>المستخدم مسؤول مسؤولية كاملة عن سرّية كلمة المرور وكل النشاط الذي يتم عبر حسابه.</li>
            <li>للمنصة الحق في تعليق أو إيقاف أي حساب بدون إنذار في حال رصد محاولات احتيال أو انتهاك للشروط.</li>
          </ul>
        </Section>

        <Section n="3" title="الإعلانات العقارية">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>يلتزم المُعلِن بأن يكون مالكاً للعقار أو وكيلاً قانونياً أو وسيطاً مرخَّصاً.</li>
            <li>يجب أن تتوافق الإعلانات مع لوائح الهيئة العامة للعقار، وأن تحمل رقم ترخيص ساري عند اللزوم.</li>
            <li>تحتفظ المنصة بحق مراجعة الإعلانات يدوياً وطلب وثائق إثبات الملكية أو التوكيل قبل النشر.</li>
            <li>يُمنع نشر عقارات وهمية، أو مكرّرة، أو بأسعار مضلّلة.</li>
            <li>مخالفة هذه البنود قد تؤدي إلى حذف الإعلان وإلغاء الاشتراك دون استرداد، وإحالة الحالة للجهات المختصة.</li>
          </ul>
        </Section>

        <Section n="4" title="المزادات الإلكترونية">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>الانضمام لأي مزاد يستلزم تسجيلاً مسبقاً وقد يتطلّب دفع تأمين قابل للاسترداد.</li>
            <li>كل مزايدة تصدر من حساب المستخدم تُعَدّ عرضاً ملزماً قانونياً.</li>
            <li>الفائز ملتزم بإتمام الشراء وفق المدة المحدّدة في إعلان المزاد، وإلا يصادَر التأمين.</li>
            <li>للمحرّج إنهاء المزاد أو إعلانه «لم يبع» مع توضيح السبب.</li>
            <li>المنصة وسيط تقني فقط، وليست طرفاً في عقد البيع النهائي.</li>
          </ul>
        </Section>

        <Section n="5" title="باقات التسويق والاشتراكات">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>تُحسَب الاشتراكات شهرياً أو سنوياً وفق الباقة المختارة (فرد/شركة).</li>
            <li>الترقية بين الباقات تتم فوراً مع احتساب الفرق نسبياً.</li>
            <li>التنزيل لباقة أقل يطبَّق في دورة الفوترة التالية.</li>
            <li>الحدود الواردة في الباقة (عدد الإعلانات، الإعلانات المميزة، الحسابات الفرعية) ملزمة، ولا يمكن تجاوزها إلا بترقية الباقة.</li>
            <li>التجديد التلقائي مفعَّل افتراضياً ويمكن إيقافه من لوحة التحكم قبل تاريخ التجديد.</li>
          </ul>
        </Section>

        <Section n="6" title="المدفوعات والاسترداد">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>تُقبَل المدفوعات عبر القنوات المعتمدة على المنصة (البطاقات، آبل باي، التحويل البنكي، المحفظة).</li>
            <li>جميع الأسعار بالريال السعودي وشاملة لضريبة القيمة المضافة ما لم يُذكر خلاف ذلك.</li>
            <li>الاشتراكات غير قابلة للاسترداد بعد ٣ أيام من الدفع، ما لم يكن هناك سبب فني موثَّق.</li>
            <li>تأمينات المزادات تُسترد خلال ٧ أيام عمل من انتهاء المزاد للمستخدمين غير الفائزين.</li>
            <li>أي نزاع مالي يُحال للقسم المالي عبر <a href="mailto:info@img.sa" className="text-navy hover:underline" dir="ltr">info@img.sa</a>.</li>
          </ul>
        </Section>

        <Section n="7" title="السلوك المحظور">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>محاولة اختراق المنصة أو التلاعب بها أو استخدام برامج آلية غير مصرَّح بها.</li>
            <li>نشر محتوى مخالف للنظام العام أو الآداب أو يحضّ على الكراهية أو يتضمّن تشهيراً.</li>
            <li>التحرّش بالمستخدمين أو إرسال بريد دعائي مزعج (سبام).</li>
            <li>انتحال شخصية الغير أو تقديم وثائق مزوّرة.</li>
            <li>أي استخدام يخالف الأنظمة السعودية أو لوائح الهيئة العامة للعقار.</li>
          </ul>
        </Section>

        <Section n="8" title="الملكية الفكرية">
          <p className="text-sm text-gray-700 leading-relaxed mb-2">
            جميع حقوق المنصة (الاسم، الشعار، التصميم، الكود، قواعد البيانات، النصوص، الواجهات) محفوظة لـ شركة صورة العقارية.
            استخدام أيٍّ منها بدون إذن خطّي مسبق يعرّض صاحبه للمساءلة القانونية.
          </p>
          <p className="text-sm text-gray-700 leading-relaxed">
            بنشرك أي محتوى على المنصة، فإنك تمنح شركة صورة العقارية رخصة عالمية غير حصرية لاستخدامه
            داخل المنصة وفي تسويق الخدمات، دون إخلال بحقوقك الأصلية.
            راجع <Link to="/copyright" className="text-navy hover:underline">صفحة حقوق الملكية</Link> لمزيد من التفاصيل.
          </p>
        </Section>

        <Section n="9" title="حدود المسؤولية">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>المنصة وسيط تقني يُسهّل التواصل بين المُعلِن والمشتري/المستأجر، وليست طرفاً في العقود الموقَّعة بين المستخدمين.</li>
            <li>لا تتحمل المنصة المسؤولية عن دقة الإعلانات أو نوايا أطرافها أو نتيجة التفاوض.</li>
            <li>يُنصَح بمعاينة العقار والتحقق من الوثائق قبل الشراء.</li>
            <li>أقصى مسؤولية مالية للمنصة في أي نزاع لا تتجاوز قيمة الاشتراك المدفوع خلال آخر ١٢ شهراً.</li>
          </ul>
        </Section>

        <Section n="10" title="حماية البيانات والخصوصية">
          <p className="text-sm text-gray-700 leading-relaxed">
            تلتزم المنصة بنظام حماية البيانات الشخصية في المملكة العربية السعودية (PDPL).
            تفاصيل جمع البيانات واستخدامها ومشاركتها موضّحة في{' '}
            <Link to="/privacy" className="text-navy hover:underline font-bold">سياسة الخصوصية</Link>،
            وهي جزء لا يتجزأ من هذه الشروط.
          </p>
        </Section>

        <Section n="11" title="إيقاف الحساب والإنهاء">
          <ul className="space-y-2 text-sm text-gray-700 leading-relaxed list-disc pr-5">
            <li>يمكن للمستخدم إغلاق حسابه في أي وقت من إعدادات الحساب.</li>
            <li>يحق للمنصة إنهاء الحساب فوراً عند ثبوت مخالفة جسيمة، مع إلغاء أي اشتراكات نشطة دون استرداد.</li>
            <li>تحتفظ المنصة بالبيانات للمدة المحدّدة نظاماً (الفواتير ١٠ سنوات، السجلات الأمنية ٧ سنوات) بعد الإغلاق.</li>
          </ul>
        </Section>

        <Section n="12" title="القانون الواجب التطبيق وفض النزاعات">
          <p className="text-sm text-gray-700 leading-relaxed">
            تخضع هذه الشروط لأنظمة المملكة العربية السعودية. عند وجود أي نزاع، تختصّ المحاكم التجارية في مدينة الرياض بالفصل فيه،
            وذلك بعد محاولة جدية للتسوية الودّية عبر إدارة شكاوى المنصة.
          </p>
        </Section>

        <Section n="13" title="تعديل الشروط">
          <p className="text-sm text-gray-700 leading-relaxed">
            تحتفظ شركة صورة العقارية بحقها في تعديل هذه الشروط في أي وقت. التعديلات تنفذ من تاريخ نشرها على الموقع،
            ويُعَدّ استمرار استخدامك للمنصة بعد النشر قبولاً ضمنياً للنسخة الجديدة.
          </p>
        </Section>

        <Section n="14" title="التواصل">
          <p className="text-sm text-gray-700 leading-relaxed">
            لأي استفسار قانوني تواصل معنا عبر:
            <br />📧 <a href="mailto:info@img.sa" className="text-navy hover:underline" dir="ltr">info@img.sa</a>
            <br />📞 <a href="tel:0114993666" className="text-navy hover:underline" dir="ltr">0114993666</a>
            <br />📍 الرياض، المملكة العربية السعودية
          </p>
        </Section>

        <Card><CardBody>
          <p className="text-xs text-gray-500 leading-relaxed text-center">
            بإكمال التسجيل أو استخدام أي خدمة من خدمات شركة صورة العقارية، تُقرّ بأنك قرأت هذه الشروط وفهمتها ووافقت عليها.
          </p>
        </CardBody></Card>
      </div>
    </div>
  );
}

function Section({ n, title, children }: { n: string; title: string; children: React.ReactNode }) {
  return (
    <Card>
      <CardBody>
        <h2 className="text-lg font-black text-navy-dark mb-3 flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-8 h-8 bg-navy text-white rounded-lg text-sm">{n}</span>
          {title}
        </h2>
        {children}
      </CardBody>
    </Card>
  );
}
